










































import { Component, Emit, Vue, Watch } from 'vue-property-decorator';

@Component({
  props: ['dataNics', 'dataNets', 'value', 'allowCustom', 'isReadonly', 'saved', 'autoselect'],
})
export default class NetworkAddressSelect extends Vue {
  searchPhrase = '';
  selectedValue = '';
  isOpened = false;
  hasError = false;
  activeItem = 0;

  @Watch('value', { immediate: true, deep: true })
  onCurrentDataChange(data: any) {
    this.selectedValue = data;
    this.searchPhrase = data;
  }

  @Watch('searchPhrase', { immediate: true, deep: true })
  onCurrentValueChange() {
    this.activeItem = 0;
    this.isOpened = this.selectedValue !== this.searchPhrase;
  }

  @Watch('autoselect')
  onAutoSelectChange() {
    if (this.isOpened) {
      this.selectFirst();
    }
  }

  @Emit()
  selectItem(item: any) {
    this.isOpened = false;
    this.selectedValue = item.value;
    this.searchPhrase = item.value;
    this.hasError = !/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/[0-9]{1,2})?$/.test(
      this.selectedValue
    );
    item.isValid = !this.hasError;
    return item;
  }

  mounted() {
    document.removeEventListener('click', this.selectFirst);
    document.addEventListener('click', this.selectFirst);
  }

  onFocus() {
    this.activeItem = 0;
    this.isOpened = true;
  }

  selectFirst() {
    if (!this.isOpened) {
      return;
    }
    const data = this.getDataForSelect(this.searchPhrase);
    if (data[this.activeItem]) {
      this.selectItem(data[this.activeItem]);
    }
  }

  resetValue() {
    this.searchPhrase = this.selectedValue;
  }

  scrollItemIntoView() {
    const element: any = this.$el.querySelector(`#item-${this.activeItem}`);
    if (element) {
      element.scrollIntoView();
    }
  }

  moveDown() {
    const data = this.getDataForSelect(this.searchPhrase);
    if (this.activeItem < data.length - 1) {
      this.activeItem += 1;
      this.scrollItemIntoView();
    }
  }

  moveUp() {
    if (this.activeItem > 0) {
      this.activeItem -= 1;
      this.scrollItemIntoView();
    }
  }

  getDataForSelect(searchPhrase: string) {
    let data: any = [];
    searchPhrase = searchPhrase || '';
    if (this.$props.dataNics) {
      data = data.concat(
        this.$props.dataNics.filter((item: any) => {
          if (item.state === 'error' || item.state === 'busy') {
            return false;
          }
          if (item.name.toLowerCase().indexOf(searchPhrase.toLowerCase()) !== -1) {
            return true;
          }
          if (item.mac_address && item.mac_address.toLowerCase().indexOf(searchPhrase.toLowerCase()) !== -1) {
            return true;
          }
          if (
            item.virtual_machine &&
            item.virtual_machine.name.toLowerCase().indexOf(searchPhrase.toLowerCase()) !== -1
          ) {
            return true;
          }
          if (
            item.dm_reservation &&
            item.dm_reservation.name.toLowerCase().indexOf(searchPhrase.toLowerCase()) !== -1
          ) {
            return true;
          }
          if (item.ip_address && item.ip_address.toLowerCase().indexOf(searchPhrase.toLowerCase()) !== -1) {
            return true;
          }
          return false;
        })
      );
    }
    if (this.$props.dataNets) {
      data = data.concat(
        this.$props.dataNets.filter((item: any) => {
          if (item.name.toLowerCase().indexOf(searchPhrase.toLowerCase()) !== -1) {
            return true;
          }
          if (item.network.toLowerCase().indexOf(searchPhrase.toLowerCase()) !== -1) {
            return true;
          }
          return false;
        })
      );
    }
    if (!data.length && this.$props.allowCustom) {
      data = [{ id: null, type: 'ip_address', value: searchPhrase, name: searchPhrase }];
    }
    return data;
  }
}
